import React from "react";
import Select from "react-select";

interface Option {
  value: string;
  label: string;
}

export const timezoneOptions: Option[] = [
  { value: "Pacific/Midway", label: "(UTC-11:00) Midway Island, Samoa" },
  { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii-Aleutian" },
  { value: "US/Hawaii", label: "(UTC-10:00) Hawaii" },
  { value: "US/Alaska", label: "(UTC-09:00) Alaska" },
  { value: "US/Pacific", label: "(UTC-08:00) Pacific Time (US & Canada)" },
  { value: "US/Mountain", label: "(UTC-07:00) Mountain Time (US & Canada)" },
  { value: "US/Central", label: "(UTC-06:00) Central Time (US & Canada)" },
  { value: "US/Eastern", label: "(UTC-05:00) Eastern Time (US & Canada)" },
  { value: "America/Caracas", label: "(UTC-04:30) Caracas" },
  { value: "Canada/Atlantic", label: "(UTC-04:00) Atlantic Time (Canada)" },
  { value: "Canada/Newfoundland", label: "(UTC-03:30) Newfoundland" },
  {
    value: "America/Argentina/Buenos_Aires",
    label: "(UTC-03:00) Buenos Aires",
  },
  { value: "Atlantic/South_Georgia", label: "(UTC-02:00) Mid-Atlantic" },
  { value: "Atlantic/Azores", label: "(UTC-01:00) Azores" },
  { value: "Europe/London", label: "(UTC+00:00) London, Lisbon, Casablanca" },
  { value: "Europe/Berlin", label: "(UTC+01:00) Berlin, Rome, Paris, Madrid" },
  { value: "Europe/Athens", label: "(UTC+02:00) Athens, Bucharest, Istanbul" },
  { value: "Europe/Moscow", label: "(UTC+03:00) Moscow, St. Petersburg" },
  { value: "Asia/Tehran", label: "(UTC+03:30) Tehran" },
  { value: "Asia/Dubai", label: "(UTC+04:00) Abu Dhabi, Muscat" },
  { value: "Asia/Kabul", label: "(UTC+04:30) Kabul" },
  { value: "Asia/Karachi", label: "(UTC+05:00) Islamabad, Karachi" },
  {
    value: "Asia/Kolkata",
    label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  },
  { value: "Asia/Kathmandu", label: "(UTC+05:45) Kathmandu" },
  { value: "Asia/Dhaka", label: "(UTC+06:00) Dhaka" },
  { value: "Asia/Bangkok", label: "(UTC+07:00) Bangkok, Hanoi, Jakarta" },
  {
    value: "Asia/Shanghai",
    label: "(UTC+08:00) Beijing, Perth, Singapore, Hong Kong",
  },
  {
    value: "Asia/Tokyo",
    label: "(UTC+09:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
  },
  { value: "Australia/Adelaide", label: "(UTC+09:30) Adelaide, Darwin" },
  {
    value: "Australia/Sydney",
    label: "(UTC+10:00) Sydney, Melbourne, Brisbane",
  },
  {
    value: "Pacific/Guadalcanal",
    label: "(UTC+11:00) Magadan, Solomon Islands, New Caledonia",
  },
  {
    value: "Pacific/Auckland",
    label: "(UTC+12:00) Auckland, Wellington, Fiji, Kamchatka",
  },
  { value: "Asia/Naypyidaw", label: "(UTC+06:30) Myanmar" },
  { value: "Asia/Manila", label: "(UTC+08:00) Philippines" },
];
interface TimezoneSelectProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
  className?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: "absolute" | "fixed";
  styles?: any;
}

export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
  value,
  onChange,
  placeholder = "Select timezone",
  isRequired = false,
  error,
  className = "",
  isClearable = true,
  isDisabled = false,
  menuPortalTarget,
  menuPosition,
  styles,
}) => {
  return (
    <>
      <Select
        options={timezoneOptions}
        value={timezoneOptions.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option?.value || "")}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        className={error ? `is-invalid ${className}` : className}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        styles={styles}
      />
      {error && <div className="text-danger mt-1">{error}</div>}
    </>
  );
};
